export default {
  sendEmail: `${process.env.REACT_APP_API_URL_1}/auth/send-mail`,
  backdoorVerify: `${process.env.REACT_APP_API_URL_1}/auth/backdoor-verify`,
  saveFcmToken: `${process.env.REACT_APP_API_URL_1}/user/saveFcmToken`,
};
